<template>
  <div class="dioptra-product-content-list dioptra-product-tab-details-content-container">
    <div v-if="topicsWithoutWarning" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Θεματολογία:</span>
      <span class="dioptra-product-tab-details-content-description">{{ topicsWithoutWarning }}</span>
    </div>
    <div v-if="productMetaData.isbn" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">ISBN:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.isbn }}</span>
    </div>
    <div v-if="productMetaData.originalTitle" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Ξενόγλωσσος τίτλος:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.originalTitle }}</span>
    </div>
    <div v-if="filterPersonsByType(persons, 7).length" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Μετάφραση:</span>
      <span class="dioptra-product-tab-details-content-description">{{ personNames(filterPersonsByType(persons, 7)) }}</span>
    </div>
    <div v-if="filterPersonsByType(persons, 5).length" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Εικονογράφος:</span>
      <span class="dioptra-product-tab-details-content-description">{{ personNames(filterPersonsByType(persons, 5)) }}</span>
    </div>
    <div v-if="productMetaData.editionValue" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">
        {{ productMetaData.editionType ? 'Έκδοση' : 'Χιλιάδα' }}:
      </span>
      <span class="dioptra-product-tab-details-content-description">
        {{ productMetaData.editionValue }}{{ productMetaData.editionType ? 'η' : '' }}
      </span>
    </div>
    <div v-if="productMetaData.firstEditionDate" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Ημερομηνία έκδοσης:</span>
      <span class="dioptra-product-tab-details-content-description">{{ formatDate(productMetaData.firstEditionDate) }}</span>
    </div>
    <div v-if="productMetaData.pages && Number(productMetaData.pages) > 0" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Αριθμός σελίδων:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.pages }}</span>
    </div>
    <div v-if="productMetaData.format" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Format:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.format }}</span>
    </div>
    <div v-if="productMetaData.size" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Μέγεθος:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.size }}</span>
    </div>
    <div v-if="productMetaData.country" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Χώρα προέλευσης:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.country }}</span>
    </div>
    <div v-if="productMetaData.ages" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Ηλικίες:</span>
      <span class="dioptra-product-tab-details-content-description">{{ productMetaData.ages }}</span>
    </div>
    <div v-if="topicsWithWarning" class="dioptra-product-tab-details-content">
      <span class="dioptra-product-tab-details-content-title">Trigger Warning:</span>
      <span class="dioptra-product-tab-details-content-description">{{ topicsWithWarning }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AdvDioptraProductTabMeta',
  props: {
    productMetaData: {
      type: Object,
      required: true
    },
    persons: {
      type: Object,
      required: false,
      default: () => ({})
    },
    topicsWithoutWarning: {
      type: String,
      required: false,
      default: ''
    },
    topicsWithWarning: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    filterPersonsByType (persons, type) {
      if (!persons || Object.keys(persons).length === 0) return {}
      return persons[type] || []
    },
    personNames (persons) {
      if (!persons || persons.length === 0) return ''
      return persons.map(person => person.translations.el.name).join(', ')
    },
    formatDate (dateString) {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(dateString).toLocaleDateString('en-GB', options)
    }
  }
}
</script>
